export interface Organization {
  organizationSignal: any | null;
  loadingSignal: boolean;
}

export const initialState: Organization = {
  organizationSignal: null,
  loadingSignal: false,
};